<router-outlet></router-outlet>


<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-member-wrapper-view></ppl-member-wrapper-view>
    </ng-template>
</div>